import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
export default class extends Controller {
  static targets = [ "mobileNav"]

  initialize() {
    // console.log("Hello from search!", this.element)
    this.setupTl()
  }

  setupTl(){
    // console.log(this.mobileNavTarget)
    this.tl = gsap.timeline({
      paused: true,
      onComplete:()=>{

      }
    })
    .fromTo(this.mobileNavTarget,.5,{
      autoAlpha:0
    },{
      autoAlpha:1,
      ease:"power4.out"
    })
  }

  toggle(){

    if(!this.tl.progress()){
      this.tl.play()
    }else{
      this.tl.reverse()
    }
  }

  submit(){

  }


  disconnect(){
    // this.hide()
  }
}